import {z} from '@hono/zod-openapi';

/** Languages supported by the versioned telephone Kafka contract. */
export const VoiceTenantLanguageSchema = z
  .enum(['cs', 'pl', 'de'])
  .openapi('VoiceTenantLanguageSchema');
